export const OPT_0_NO_MATCHING = 0;
export const OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF = 1;
export const OPT_2_PREMIUM_CLOSE_TO = 2;
export const OPT_3_PREMIUM_RANGE = 3;
export const OPT_4_COMB_PREM = 4;

export const filterMatching = (
  matching,
  currunt = 'NO_MATCHING',
  status = false
) => {
  const matchingNew = [...matching];

  switch (currunt) {
    case 'NO_MATCHING':
      matchingNew[OPT_0_NO_MATCHING].active = true;

      matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].active = false;
      matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].maxDiff = 1;

      matchingNew[OPT_2_PREMIUM_CLOSE_TO].active = false;
      matchingNew[OPT_2_PREMIUM_CLOSE_TO].premiumCloseTo = 1;

      matchingNew[OPT_3_PREMIUM_RANGE].active = false;
      matchingNew[OPT_3_PREMIUM_RANGE].lower = 1;
      matchingNew[OPT_3_PREMIUM_RANGE].upper = 1;

      matchingNew[OPT_4_COMB_PREM].active = false;
      matchingNew[OPT_4_COMB_PREM].type = 'LT';
      matchingNew[OPT_4_COMB_PREM].val1 = 1;
      delete matchingNew[OPT_4_COMB_PREM].val2;
      break;
    case 'MATCH_PREMIUM_WITH_MAX_DIFF':
      if (status === true) {
        matchingNew[OPT_0_NO_MATCHING].active = false;

        matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].active = true;
        matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].maxDiff = 1;

        matchingNew[OPT_4_COMB_PREM].active = false;
        matchingNew[OPT_4_COMB_PREM].type = 'LT';
        matchingNew[OPT_4_COMB_PREM].val1 = 1;
        delete matchingNew[OPT_4_COMB_PREM].val2;
      } else {
        if (
          matchingNew[OPT_2_PREMIUM_CLOSE_TO].active === true ||
          matchingNew[OPT_3_PREMIUM_RANGE].active === true
        ) {
          matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].active = false;
          matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].maxDiff = 1;
        }
      }
      break;
    case 'PREMIUM_CLOSE_TO':
      if (status === true) {
        matchingNew[OPT_0_NO_MATCHING].active = false;

        matchingNew[OPT_2_PREMIUM_CLOSE_TO].active = true;
        matchingNew[OPT_2_PREMIUM_CLOSE_TO].premiumCloseTo = 1;

        matchingNew[OPT_3_PREMIUM_RANGE].active = false;
        matchingNew[OPT_3_PREMIUM_RANGE].lower = 1;
        matchingNew[OPT_3_PREMIUM_RANGE].upper = 1;

        matchingNew[OPT_4_COMB_PREM].active = false;
        matchingNew[OPT_4_COMB_PREM].type = 'LT';
        matchingNew[OPT_4_COMB_PREM].val1 = 1;
        delete matchingNew[OPT_4_COMB_PREM].val2;
      } else {
        if (matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].active === true) {
          matchingNew[OPT_2_PREMIUM_CLOSE_TO].active = false;
          matchingNew[OPT_2_PREMIUM_CLOSE_TO].premiumCloseTo = 1;
        }
      }
      break;
    case 'PREMIUM_RANGE':
      if (status === true) {
        matchingNew[OPT_0_NO_MATCHING].active = false;

        matchingNew[OPT_2_PREMIUM_CLOSE_TO].active = false;
        matchingNew[OPT_2_PREMIUM_CLOSE_TO].premiumCloseTo = 1;

        matchingNew[OPT_3_PREMIUM_RANGE].active = true;
        matchingNew[OPT_3_PREMIUM_RANGE].lower = 1;
        matchingNew[OPT_3_PREMIUM_RANGE].upper = 1;

        matchingNew[OPT_4_COMB_PREM].active = false;
        matchingNew[OPT_4_COMB_PREM].type = 'LT';
        matchingNew[OPT_4_COMB_PREM].val1 = 1;
        delete matchingNew[OPT_4_COMB_PREM].val2;
      } else {
        if (matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].active === true) {
          matchingNew[OPT_3_PREMIUM_RANGE].active = false;
          matchingNew[OPT_3_PREMIUM_RANGE].lower = 1;
          matchingNew[OPT_3_PREMIUM_RANGE].upper = 1;
        }
      }
      break;
    case 'COMB_PREM':
      if (status === true) {
        matchingNew[OPT_0_NO_MATCHING].active = false;

        matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].active = false;
        matchingNew[OPT_1_MATCH_PREMIUM_WITH_MAX_DIFF].maxDiff = 1;

        matchingNew[OPT_2_PREMIUM_CLOSE_TO].active = false;
        matchingNew[OPT_2_PREMIUM_CLOSE_TO].premiumCloseTo = 1;

        matchingNew[OPT_3_PREMIUM_RANGE].active = false;
        matchingNew[OPT_3_PREMIUM_RANGE].lower = 1;
        matchingNew[OPT_3_PREMIUM_RANGE].upper = 1;

        matchingNew[OPT_4_COMB_PREM].active = true;
        matchingNew[OPT_4_COMB_PREM].type = 'LT';
        matchingNew[OPT_4_COMB_PREM].val1 = 1;
        delete matchingNew[OPT_4_COMB_PREM].val2;
      } else {
        matchingNew[OPT_4_COMB_PREM].active = false;
        matchingNew[OPT_4_COMB_PREM].type = 'LT';
        matchingNew[OPT_4_COMB_PREM].val1 = 1;
        delete matchingNew[OPT_4_COMB_PREM].val2;

        matchingNew[OPT_0_NO_MATCHING].active = true;
      }
      break;
    default:
      console.log('Wrong Matching opt');
  }

  return matchingNew;
};
